import { A9Service, AbstractDataProviderV2 } from 'components/system';

@A9Service('customerHandicapYearStatisticsDataProvider')
export class CustomerHandicapYearStatisticsDataProvider extends AbstractDataProviderV2 {
    constructor() {
        super();
        this.setApiUrl('middle://customers/statistics/handicap-year/{customerId}/{year}');
    }
}
